const setIsServerConnectableAction = ({ commit }, payload) => {
  commit('setIsServerConnectable', payload)
}

const setShowingSlideGridAction = ({ commit }, payload) => {
  commit('setShowingSlideGrid', payload)
}

const setIsWelcomePopupShowingAction = ({ commit }, payload) => {
  if (payload) {
    document.body.classList.add('no-scroll')
  } else {
    document.body.classList.remove('no-scroll')
  }

  commit('setIsWelcomePopupShowing', payload)
}

const setHasOnboardingV3Action = ({ commit }, payload) => {
  commit('setHasOnboardingV3', payload)
}

const setIsOnboardingV3ShowingAction = ({ commit }, payload) => {
  if (payload) {
    document.body.classList.add('no-scroll')
  } else {
    document.body.classList.remove('no-scroll')
  }
  commit('setIsOnboardingV3Showing', payload)
}

export default {
  setIsServerConnectableAction,
  setShowingSlideGridAction,
  setIsWelcomePopupShowingAction,
  setHasOnboardingV3Action,
  setIsOnboardingV3ShowingAction,
}
